import type { ReactElement } from 'react';
import { CSVLink } from 'react-csv';
import type { Data } from 'react-csv/lib/core';
import type { UIComponentProps } from '../types/UI';
import { cn } from '../utils/classnames';

export type CSVDocumentProps<T> = UIComponentProps & {
  fileName?: string;
  data: T;
};

export function CSVDownloadLink<T extends Data>({
  data,
  fileName = 'download.csv',
  className,
  children,
}: CSVDocumentProps<T>): ReactElement {
  return (
    <CSVLink data={data} filename={fileName} className={cn(className)} target="_blank">
      {children}
    </CSVLink>
  );
}
